import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=040ddb9d&"
import script from "./Debt.vue?vue&type=script&lang=js&"
export * from "./Debt.vue?vue&type=script&lang=js&"
import style0 from "./Debt.vue?vue&type=style&index=0&id=040ddb9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Debt.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports